import { useEffect, useState } from "react";
import { isLoggedIn } from "core/services/Auth";
import { CONFIG } from "core/config";
import history from "App/History";
import { getHomePage } from "core/services/RBAC";
import EyeOpen from "shared/Icons/EyeOpen";
import { Field, InjectedFormProps, reduxForm } from "redux-form";
import ShadedInput from "shared/components/redux-form/ShadedInput";
import EyeClose from "shared/Icons/EyeClose";
import validate from "./validate";
import ArenaLogo from "assets/icons/ArenaEsports.png";
import { Button } from "rsuite";
import googleLogo from "../../assets/icons/logo-google.png";
import moderatorLogo from "../../assets/icons/tag-user.png";

interface FormData {
  userName: string;
  password: string;
}

interface LoginProps {
  onPageSwitch?(page: string): void;
  onResetPassword?(): void;
  onLogin?(data: any): void;
}

type FinalProps = InjectedFormProps<FormData, LoginProps> & LoginProps;

function Login({
  handleSubmit,
  onPageSwitch,
  onResetPassword,
  onLogin,
}: FinalProps) {
  const [inputHidden, setInputHidden] = useState(true);

  useEffect(() => {
    if (isLoggedIn()) {
      history.replace(getHomePage());
    }
  }, []);

  function handleForm(formdata: FormData) {
    if (onLogin) {
      onLogin({ ...formdata, loginType: "email" });
    }
  }

  function togglePasswordVisibility() {
    setInputHidden((prev) => !prev);
  }

  function handlePageSwitch() {
    if (onPageSwitch) {
      onPageSwitch("signup");
    }
  }

  function handleGoogleLogin() {
    const gauthUrl = new URL(CONFIG.gauthOAuth);
    gauthUrl.searchParams.append("client_id", CONFIG.gauthClientId);
    gauthUrl.searchParams.append(
      "redirect_uri",
      `${window.location.origin}${CONFIG.redirectUrl}`
    );
    gauthUrl.searchParams.append("response_type", "code");
    gauthUrl.searchParams.append("scope", "email profile openid");
    gauthUrl.searchParams.append("state", "login");
    window.location.href = gauthUrl.toString();
  }

  return (
    <div className="login-container">
      <div className="logo-container">
        <img src={ArenaLogo} alt="Arena Logo" className="arena-logo" />
      </div>
      <div className="welcome-text">Welcome to Hub!</div>
      <div className="sub-head">Login to your account</div>
      <form
        className="form-wrapper"
        autoComplete="off"
        onSubmit={handleSubmit(handleForm)}
      >
        <div className="login-control">
          <Field
            name="email"
            component={ShadedInput}
            label="UserName or Email"
            placeholder="Enter Email"
            props={{
              className: "shaded-blue",
              labelClassName: "label-white",
            }}
          />
        </div>
        <div className="login-control">
          <Field
            name="password"
            type={inputHidden ? "password" : "text"}
            component={ShadedInput}
            label="Password"
            placeholder="Enter Password"
            autoComplete="new-password"
            icon={
              inputHidden ? (
                <EyeClose fontSize={20} />
              ) : (
                <EyeOpen fontSize={18} />
              )
            }
            withButton={true}
            onClick={togglePasswordVisibility}
            props={{
              className: "shaded-blue",
              labelClassName: "label-white",
            }}
          />
        </div>
        <span className="forgot-password-cta">
          <button
            type="button"
            className="forgot-password"
            onClick={onResetPassword}
          >
            Forgot password?
          </button>
        </span>
        <Button type="submit" className="login-btn">
          Login
        </Button>
      </form>
      <div className="switch-sign-up">
        <span>Don&apos;t have an account?</span>
        <span className="sign-in" onClick={handlePageSwitch}>
          Sign up
        </span>
      </div>
      <div className="third-part-sign-in-container">
        <div className="login-text">
          <span className="hr-line"></span>
          <span>Or login with</span>
          <span className="hr-line"></span>
        </div>
        <div className="third-part-sign-in-btns" onClick={handleGoogleLogin}>
          <img src={googleLogo} alt="google-logo" /> Sign in with Google
        </div>
        <a href={CONFIG.moderatorUrl} className="third-part-sign-in-btns">
          <img src={moderatorLogo} alt="moderator-logo" />
          Moderator Sign In
        </a>
      </div>
    </div>
  );
}

export default reduxForm<FormData, LoginProps>({
  form: "hub-login",
  validate,
  shouldValidate: () => true,
})(Login);
